
<style>
  .speaker-title {
    font-size: 1.1rem;
    font-weight: 600;
    font-style: italic;
    color: #2c3e46;
    margin: 0.3rem 0 0.8rem 0;
  }
    .talk-title {
    font-size: 1.1rem;
    font-weight: 600;
    font-style: italic;
    color: #f39c12;
    margin: 0.3rem 0 0.8rem 0;
  }
  .session-title {
    font-size: 1.3rem;
    font-weight: bold;
    color: #2c3e50;
    margin: 1.2rem 0 0.6rem 0;
 
  }
  section {
  scroll-margin-top: 80px; /* spazio per l’header */
}
.time-slot {
  font-size: 1.0rem;           /* più grande */
  color: #2c3e50;              /* colore elegante */
  font-weight: 700;            /* grassetto */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  letter-spacing: 0.05em;      /* spaziatura lettere */
  white-space: nowrap;         /* non va a capo */

  
  }
</style>
<h1> PROGRAM </h1>

 <p class="speaker-title" align="center">
  <a href="">Download the full program (Da Inserire link al programma)</a>
 </p>
 
<div class="text">
  <h2 style="margin-top: 2.5rem; color: #2c3e50; font-size: 1.5rem;">
    <b>October 5th, 2026 <br> Roma Tre University</b>
</h2>
  <hr>
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">08:30 - 09:00</p> <h3 class="session-title">Registration and badge </h3></div>
  <hr>
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">09:00 - 09:15</p> <h3 class="session-title">Welcome speech and introduction</h3> <i>(in italian)</i>
    <ul>
      <li><p class="speaker-title">Massimiliano Sala (DeCifris)</p>
      <li><p class="speaker-title">Marco Pedicini (Università RomaTre)</p>
      <!-- <li><p class="speaker-title">Alessandro Casale (ACN)</p> -->
</ul>
  </div>
  <hr>
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">09:15 - 10:00</p>  <h3 class="session-title"><b>Institutional round table</b></h3><i>(in italian)</i>
    <p class="speaker-title">Moderatore: INSERIRE </p>
    <ul>
      <li> <p class="speaker-title">INSERIRE<p>
      <li> <p class="speaker-title">INSERIRE<p>
      </ul>
  </div>
  <hr>
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">10:00 - 10:30</p> <h3 class="session-title"><b>De Cifris Partners</b></h3><i>(in italian)</i>
    <p class="speaker-title">Inserire SPEAKER; <p></div>
  <hr>
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">10:30 - 11:00</p> <h3 class="session-title">Panel</h3><i>(in italian)</i>
     <p class="speaker-title">Moderatore: INSERIRE </p>
    <ul>
      <li>Inserire speakers</li>
      </ul>
  </div>
  <hr>
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">11:00 - 11:15</p>  <p class="speaker-title">Coffee break</p></div>
  <div style="margin-bottom: 1.2rem;">
    <hr>
    <p class="time-slot">11:15 - 12:45</p> 
    <h3 class="session-title"><b>I° Scientific Session</b></h3>
    <p class="speaker-title">INSERIRE </p><p class="talk-title">Titolo</p> 
    <hr>
    <p class="time-slot">11:15 - 11:45</p>
    <h3 class="session-title"><b> I° Talk </b></h3>
    
    <p class="time-slot">11:45 - 12:15</p>
    <h3 class="session-title"><b> II° Talk </b></h3>

    <p class="time-slot">12:15 - 12:45</p>
    <h3 class="session-title"><b> III° Talk </b></h3>

  </div>
  <hr>
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">12:45 - 14:00</p> <p class="speaker-title">Lunch break</p></div>
  <hr>


  <div style="margin-bottom: 1.2rem;">
    <hr>
    <p class="time-slot">14:00 - 15:30</p> 
    <h3 class="session-title"><b>II° Scientific Session</b></h3>
    <p class="speaker-title">INSERIRE </p><p class="talk-title">Titolo</p> 
    <hr>
    <p class="time-slot">14:00 - 14:30</p>
    <h3 class="session-title"><b> IV° Talk </b></h3>
    
    <p class="time-slot">14:30 - 15:00</p>
    <h3 class="session-title"><b> V° Talk </b></h3>

    <p class="time-slot">15:00 - 15:30</p>
    <h3 class="session-title"><b> VI° Talk </b></h3>
  </div>

  <hr>
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">15:30 - 15:45</p>  <p class="speaker-title">Coffee break</p></div>
  <hr>
  
  <div style="margin-bottom: 1.2rem;"><p class="time-slot">15:45 - 18:45</p>  <p class="speaker-title">Workshops Session</p></div>
  <hr>

